<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1#P1">P<span class="small">ART</span> I. C<span class="small">RYPTIDS</span>, M<span class="small">ONSTERS AND</span> O<span class="small">UT-OF</span>-P<span class="small">LACE</span> A<span class="small">NIMALS</span></a></p>
<p class="toc"><a href="#/Chapter1#C1">Chapter 1. Big Cats</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">Chapter 2. Bigfoot in the Mountains</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">Chapter 3. Werewolves and Dogmen</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">Chapter 4. Phantom Dogs</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Chapter 5. Other Strange Creatures</span></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample">P<span class="small">ART</span> II. H<span class="small">IDDEN</span> H<span class="small">ISTORY</span></span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">Chapter 6. Giants, Mounds and More</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">Chapter 7. The Mysterious Melungeons</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">Chapter 8. There’s Gold in Them Hills!</span></p>
<p class="toc1"><span href="#/Part3#P3" title="Link target outside of Sample">P<span class="small">ART</span> III. E<span class="small">ERIE</span> T<span class="small">ALES</span></span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">Chapter 9. The Dark Side of Shenandoah National Park</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10. A Virginia Ghost Town</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">Chapter 11. UFOs and Aliens</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">Chapter 12. A Vast Underworld</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?33554bcd